<template>
  <el-row type="flex">
    <el-col :span="4">
      <el-container id="NavMenu">
        <el-main>
          <el-menu
            :default-active="$route.path"
            :router="true"
            id="menu">
            <el-menu-item
              v-for="item in navMenu"
              v-if="!item.children && !item.hidden && item.index"
              :key="item.index"
              :index="item.index">
              <icon-svg :icon-class="item.icon" :size="item.size || '2em'" :margin="item.margin"></icon-svg>
              <span slot="title">{{item.name}}</span>
            </el-menu-item>
            <el-submenu
              v-else-if="!item.hidden"
              :index="item.index">
              <template slot="title">
                <icon-svg :icon-class="item.icon" :size="item.size" :margin="item.margin"></icon-svg>
                {{item.name}}
              </template>
              <el-menu-item-group>
                <el-menu-item
                  v-for="item1 in item.children"
                  v-if="item1.index"
                  :key="item1.index"
                  :index="item1.index">
                  {{item1.name}}
                </el-menu-item>
              </el-menu-item-group>
            </el-submenu>
          </el-menu>
        </el-main>
      </el-container>
    </el-col>
    <el-col :span="20">
      <router-view></router-view>
    </el-col>
  </el-row>
</template>

<script>
import menu from '../../router/menu'

export default {
  name: 'NavMenu',
  computed: {
    navMenu () {
      return this.show('type' + localStorage[`$_${this.getDomain()}type`], menu)
    }
  },
  methods: {
    show (val, list) {
      list.forEach(item => {
        if (item.meta && item.meta[val]) {
          item.hidden = false
        }
        if (item.children) {
          item.children.forEach(child => {
            if (child.meta && child.meta[val]) {
              item.hidden = false
            }
          })
        }
      })
      return list
    }
  }
}
</script>

<style scoped>
  #menu {
    border-right: none;
  }
</style>
